import { useState, useEffect } from "react";
import { crearUsuario, getMedicos, asignarUsuarioAMedico } from "../../api/apiResources";
import "./CrearUsuarioModal.css";

const CrearUsuarioModal = ({ onClose, onSuccess }) => {
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        rol: "medico",
        medicoId: ""
    });
    const [medicos, setMedicos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchMedicos = async () => {
            try {
                const data = await getMedicos();
                // Opcional: filtrar medicos que ya tienen usuario, 
                // pero si no sabemos la data exacta, mostramos todos
                setMedicos(data);
            } catch (err) {
                console.error(err);
            }
        };
        if (formData.rol === "medico") {
            fetchMedicos();
        }
    }, [formData.rol]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            // 1. Crear usuario
            const usuarioPayload = {
                username: formData.username,
                password: formData.password,
                rol: formData.rol
            };
            
            const newUser = await crearUsuario(usuarioPayload);
            const newUserId = newUser.id || newUser._id || (newUser.data && (newUser.data.id || newUser.data._id));
            
            if (!newUserId) {
                throw new Error("No se pudo obtener el ID del usuario creado.");
            }

            // 2. Si es médico y se seleccionó uno, asignar
            if (formData.rol === "medico" && formData.medicoId) {
                await asignarUsuarioAMedico(formData.medicoId, newUserId);
            }

            onSuccess();
            onClose();
        } catch (err) {
            setError(err.response?.data?.error || err.message || "Error al crear usuario");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Crear Nuevo Usuario</h2>
                {error && <div className="modal-error">{error}</div>}
                
                <form onSubmit={handleSubmit} className="crear-usuario-form">
                    <label>
                        Usuario:
                        <input 
                            type="text" 
                            name="username" 
                            value={formData.username} 
                            onChange={handleChange} 
                            required 
                        />
                    </label>
                    <label>
                        Contraseña:
                        <input 
                            type="password" 
                            name="password" 
                            value={formData.password} 
                            onChange={handleChange} 
                            required 
                            minLength={6}
                        />
                    </label>
                    <label>
                        Rol:
                        <select name="rol" value={formData.rol} onChange={handleChange}>
                            <option value="medico">Médico</option>
                            <option value="paciente">Paciente</option>
                            <option value="admin">Admin</option>
                        </select>
                    </label>

                    {formData.rol === "medico" && (
                        <label>
                            Asignar a Médico (Opcional):
                            <select name="medicoId" value={formData.medicoId} onChange={handleChange}>
                                <option value="">Seleccione un médico</option>
                                {medicos.map(medico => (
                                    <option key={medico.id || medico._id} value={medico.id || medico._id}>
                                        {medico.nombre} {medico.apellido} - {medico.matricula}
                                    </option>
                                ))}
                            </select>
                        </label>
                    )}

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} disabled={loading} className="btn-cancel">
                            Cancelar
                        </button>
                        <button type="submit" disabled={loading} className="btn-submit">
                            {loading ? "Creando..." : "Crear y Asignar"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CrearUsuarioModal;
